import React from "react";
import todoStore, { actions } from "./store";
import TodoItem from "./TodoItem";
import "./style.css";

function clickAdd(e: React.KeyboardEvent<HTMLInputElement>) {
  if (e.keyCode === 13) {
    const target = e.currentTarget;
    if (target.value.trim() !== "") {
      actions.addTodo(target.value);
    }
    target.value = "";
  }
}

export default function TodoList() {
  const { todos, editId } = todoStore.useState("todos", "editId");
  const todoNum = todos.filter(item => !item.complete).length;

  return (
    <div className="todoList">
      <div style={{ marginBottom: 16 }}>
        待办: {todoNum}, 已完成 {todos.length - todoNum}{" "}
      </div>
      <div className="inner">
        <input
          className="addTodo"
          placeholder="添加待办"
          onKeyDown={clickAdd}
        />
        <ul>
          {todos
            .sort((a, b) => b.id - a.id)
            .map(todo => {
              const props: any = { ...todo };
              props.editing = editId === todo.id;
              return <TodoItem key={todo.id} {...props} />;
            })}
        </ul>
      </div>
    </div>
  );
}
